import { render } from "./Pdf.vue?vue&type=template&id=196d8dec"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__